export default __webpack_public_path__ + "static/media/sort.f50a9112.svg";